import { menusUrl, productsUrl } from "../resources";
import getRequest from '../common/getRequest.js';

async function getMenusByRestaurant(restaurantId, token) {

    let url = `${menusUrl}/GetActiveMenusByRestaurant/${restaurantId}`;
    let data;

    await getRequest.getDataWithToken(url, token)
                .then(res => {
                    data = res
                });

    return data;
}

async function getItemsInRepositoryByRestaurant(restaurantId, token) {
    
    let url = `${productsUrl}/getbyrestaurant/${restaurantId}`;
    let data;
    await getRequest.getDataWithToken(url, token)
                .then(res => {
                    data = res.items
                });
    return data;
}


export default {
    getMenusByRestaurant,
    getItemsInRepositoryByRestaurant
}